var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLogged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFCFCF;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.6293;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.6293;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D2D2D2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.3,11.1c1.3,0,2.3-1.1,2.3-2.3s-1-2.3-2.3-2.3S225,7.5,225,8.8S226.1,11.1,227.3,11.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.6,173c1.3,0,2.3-1.1,2.3-2.3s-1-2.3-2.3-2.3c-1.3,0-2.3,1.1-2.3,2.3S242.4,173,243.6,173z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.6,92.8c-20,0-40.4-0.8-59.4-6.1c-19-5.3-35.8-15.2-51.2-26.9c-10-7.6-19.2-13.6-32.1-12.7 C57.2,47.8,45,52.5,35.2,60.6c-16.6,14.5-14,41.3-7.4,60.1c9.9,28.4,40.2,48.1,65.9,60.9c29.7,14.8,62.3,23.5,95.1,28.4 c28.9,4.4,65.5,7.5,90.4-11.2c22.8-17.2,29.1-56.5,23.5-83c-1.4-7.8-5.5-14.9-11.7-19.9c-16-11.7-40-3.9-58-3.5 C226.3,92.6,219.5,92.8,212.6,92.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.1,54.9v10.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287,60.1h10.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,256.6c48.5,0,87.7-2.4,87.7-5.5c0-3-39.3-5.5-87.7-5.5s-87.7,2.4-87.7,5.5 C75.9,254.1,115.2,256.6,163.7,256.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261,57.5L79.3,41.4c-5.3-0.4-9.9,3.4-10.4,8.7L57.6,177.9c-0.5,5.3,3.4,9.9,8.7,10.4L248,204.3 c5.3,0.5,9.9-3.4,10.4-8.7l11.3-127.7C270.1,62.7,266.2,58,261,57.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.1,104.2l-102.7-9.1c-2.4-0.2-4.5,1.6-4.7,4l-0.6,7.2c-0.2,2.4,1.6,4.5,4,4.7l102.7,9.1 c2.4,0.2,4.5-1.6,4.7-4l0.6-7.2C221.2,106.6,219.5,104.4,217.1,104.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M214.3,135.1L111.6,126c-2.4-0.2-4.5,1.6-4.7,3.9l-0.6,7.2c-0.2,2.4,1.6,4.5,4,4.7l102.7,9.1 c2.4,0.2,4.5-1.6,4.7-3.9l0.6-7.2C218.5,137.4,216.7,135.3,214.3,135.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.7,163.5l-34.9-3.1c-1.8-0.2-3.5,1.2-3.6,3l-0.8,9.2c-0.2,1.8,1.2,3.4,3,3.6l34.9,3.1 c1.8,0.2,3.5-1.2,3.6-3l0.8-9.2C180.8,165.3,179.5,163.7,177.7,163.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.1,48.7c0,6-1.8,11.9-5.1,16.9c-3.3,5-8.1,8.9-13.7,11.2c-5.6,2.3-11.7,2.9-17.6,1.7 c-5.9-1.2-11.3-4.1-15.6-8.3c-4.3-4.3-7.2-9.7-8.3-15.6c-1.2-5.9-0.6-12,1.7-17.6c2.3-5.6,6.2-10.3,11.2-13.7 c5-3.3,10.9-5.1,16.9-5.1c4,0,8,0.8,11.7,2.3c3.7,1.5,7.1,3.8,9.9,6.6c2.8,2.8,5.1,6.2,6.6,9.9C193.4,40.7,194.1,44.7,194.1,48.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.9,68.5c-2.9,3.3-6.4,6-10.4,7.8c-4,1.8-8.3,2.8-12.7,2.8c-4.4,0-8.7-0.9-12.7-2.8c-4-1.8-7.5-4.5-10.4-7.8 c0.4-5.9,3-11.3,7.3-15.4c4.3-4,9.9-6.2,15.8-6.2c5.9,0,11.5,2.2,15.8,6.2C183.9,57.1,186.5,62.6,186.9,68.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.7,42.3c5.5,0,10-4.5,10-10s-4.5-10-10-10s-10,4.5-10,10S158.1,42.3,163.7,42.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.6,109.7c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5C133,107.7,135.1,109.7,137.6,109.7 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.9,111.3c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5 C151.3,109.3,153.4,111.3,155.9,111.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.2,113c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5C169.6,110.9,171.7,113,174.2,113z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.5,114.6c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5C187.9,112.5,190,114.6,192.5,114.6 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLogged);
export default __webpack_public_path__ + "static/media/no-logged.978ba4a32fb23c590878b520230afae6.svg";
export { ForwardRef as ReactComponent };